import { AUTH_SYSTEM } from '@/constants/auth/user'
import type { AuthSystem } from '@/types/auth/user'

/**
 * ユーザIDから所属している認証システムを判定する
 * @param userId ユーザID
 * @returns 認証システム
 */
export const getAuthSystemByUserId = (userId: string): AuthSystem =>
  userId.startsWith('DUP-') ? AUTH_SYSTEM.DUP : AUTH_SYSTEM.DISASTER

/**
 * ユーザIDから自治体コードを取得する
 * @param userId ユーザID
 * @param authSystem 所属認証システム
 * @returns 自治体コード
 */
export const getGovCodeByUserId = (userId: string, authSystem?: AuthSystem): string => {
  if (authSystem == null) {
    authSystem = getAuthSystemByUserId(userId)
  }

  if (authSystem === AUTH_SYSTEM.DUP) {
    return userId.slice(4, 9)
  }
  return userId.slice(0, 5)
}

/**
 * ユーザIDから団体コードを取得する
 * @param userId ユーザID
 * @returns 団体コード
 */
export const getOrganizationCodeByUserId = (
  userId: string,
  authSystem?: AuthSystem
): string | undefined => {
  if (authSystem == null) {
    authSystem = getAuthSystemByUserId(userId)
  }
  if (authSystem === AUTH_SYSTEM.DUP) {
    return userId.slice(10, 15)
  }
  return undefined
}
